export const formatCentsToDollars = (cents?: number): string => {
  if (cents == null || isNaN(cents)) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
};

export const toPercentage = (bps?: number): string => {
  if (bps == null || isNaN(bps)) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumSignificantDigits: 1,
  }).format(bps / 10000);
};
